import { render, staticRenderFns } from "./client-tab-other.vue?vue&type=template&id=9fe1676e"
import script from "./client-tab-other.vue?vue&type=script&lang=ts"
export * from "./client-tab-other.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports